export enum BatchState {
  GREIG = 'greig',
  OFFSITE = 'offsite',
  FINISHED = 'finished',
  AVAILABLE = 'available',
  DISPATCHED = 'dispatched'
}

export enum BatchStateValue {
  GREIG = 0,
  OFFSITE = 1,
  FINISHED = 2,
  AVAILABLE = 3,
  DISPATCHED = 4
}

export type QualityCheck = {
  id?: string
  returnedBatchId: any
  qualityCheckStatus: QualityControlStatus
  testerName: string
  qualityCheckSupplierId: string
  dateCarriedOut: string
  notes: string
  rollIds: ReturnedRoll[]
}

export type FireTesting = {
  id?: string
  returnedBatchId: any
  fireTestingStatus: FireTestingStatus
  fireTestSupplierId: string
  testType?: string
  dateCarriedOut: string
  notes: string
  fireTestCertificateFile?: any
  lastEditedBy?: string
}
export type ReturnedBatch = {
  id?: string
  previousBatchId?: string
  batchNumber: string
  supplierId?: string
  purchaseOrderReference?: string
  totalLengthValue?: number
  totalLengthUnit?: number
  totalWeight?: number
  totalPercentageWeightLostOrGained?: number
  bay?: string
  dateReturned?: string
  dateDispatched: string
  notes?: string
  lastEditedBy?: string
  machineNumber?: string
  rollIds?: ReturnedRoll[]
  returnedRolls?: ReturnedRoll[]
  qualityChecks?: QualityCheck[]
  fireTests?: FireTesting[]
}
export type FinishedBatch = {
  id?: string
  previousBatchId?: string
  batchNumber?: string
  finishingSupplierId?: string
  finishingQualityId?: string
  purchaseOrderReference?: string
  totalLengthValue?: number
  totalLengthUnit?: number
  totalWeight?: number
  totalPercentageWeightLostOrGained?: number
  bay?: string
  dateReturned?: string
  dateDispatched?: string
  notes?: string
  lastEditedBy?: string
  machineNumber?: string
  returnedRolls: ReturnedRoll[]
  qualityChecks: QualityCheck[]
  fireTests: FireTesting[]
  quality?: BatchQuality
}

export type ReturnedRoll = {
  id?: string
  previousRollId?: string
  originalBatchNumber?: string
  currentBatchNumber?: string
  rollNumber: string
  newLengthValue: number
  newLengthUnit: number
  newWeight: number
}

export type ReturnBatch = {
  id?: string
  batchNumber: string
  finishingSupplierId?: string
  finishingQualityId?: string
  dateReturned?: string
  weight?: number
  lengthValue?: number
  lengthUnit?: number
  totalPercentageWeightLostOrGained?: number
  purchaseOrderReference?: string
  notes?: string
  lastEditedBy?: string
  rolls?: BatchRoll[]
  qualityChecks?: QualityCheck[]
  fireTests?: FireTesting[]
}

export type ReturnBatchRoll = {
  id?: string
  rollNumber?: string
  newLengthValue?: number
  newLengthUnit?: number
  newWeight?: number
  lengthValue?: number
  lengthUnit?: number
  weight?: number
}

export type Batch = {
  id?: string
  returnedBatchId?: string
  batchNumber?: string
  state?: number
  knittingSupplierId?: string
  finishingSupplierId?: string
  knittingQualityId?: string
  finishingQualityId?: string
  supplier?: String
  dateKnitted?: string
  weight?: number
  bay?: string
  costPerKgAmount?: number
  costPerKgCurrency?: number
  costPerMetreAmount?: number
  costPerMetreCurrency?: number
  machineNumber?: string
  purchaseOrderReference?: string
  notes?: string
  createdAt?: string
  dateSentToSupplier?: string;
  rolls?: BatchRoll[]
  batchMerges?: BatchMerge[],
  quality?: BatchQuality
}
export type BatchMerge = {
  id?: string,
  mergeId: string,
  kiloOfYarnUsed: number,
  kiloOfYarnWasted: number,
}

export type BatchRoll = {
  id?: string
  rollNumber: string
  supplierRollNo?: string
  batchId?: string
  previousBatchId?: string
  returnedRollId?: string
  isActive: boolean
  lengthValue?: number
  lengthUnit?: number
  weight?: number
  mergeNumber?: string
  dateKnitted?: string
  rollState: number
  originalBatchNumber?: string
  currentBatchNumber?: string
  newLengthValue?: number
  newLengthUnit?: number
  newWeight?: number
}

export type BatchPostRoll = {
  rollNo?: number | null
  lengthValue?: number | null
  lengthUnitValue?: number | null
  weight?: number | null
  rollState?: number | null
  supplierRollNo?: number | null
  mergeNumber?: string | null
}

export type BatchQuality = {
  name: string
}

export enum FireTestingStatus {
  PENDING = 0,
  PASSED = 1,
  FAILED = 2
}

export type BatchFireTesting = {
  testType: string
  status: FireTestingStatus
  dateCarriedOut: string
  supplier: string
}

export enum QualityControlStatus {
  PENDING = 0,
  PASSED = 1,
  QUARANTINE = 2,
}

export type BatchQualityControl = {
  status: QualityControlStatus
  Tester: string
  dateCarriedOut: string
  rollsUsed: BatchQualityControlRoll[]
}

export type BatchQualityControlRoll = {
  roll: BatchRoll
  notes: string
}

export interface MergeUsage {
  mergeId: string
  mergeNumber: string
  kiloUsed: number
  kiloWasted: number
}

export interface Roll {
  id: string
  rollNumber: number | null
  batchId?: string
  knittingQualityId?: string
  rollState: number
  supplierRollNo: number | null
  lengthValue: number | null
  lengthUnit: number | null
  weight: number | null
  mergeNumber: number
  bay?: string
  isActive: boolean
  originalBatchNumber?: string
  currentBatchNumber?: string
}

export interface BatchSupplier {
  batchId: string
  supplierId: string
  supplierName: string
  supplierAddressId: string
  purchaseOrderNumber: string
  rollStatus: number
  packingListReference: string
  qualityId: string
  rolls: { rollId: string }[]
  notes: string
}
